/* eslint-disable react/prop-types */
import MKBox from "components/MKBox";
import Container from "@mui/material/Container";
import "devextreme/dist/css/dx.light.css";
import MKTypography from "components/MKTypography";

function PropertyDetails({ property }) {
  return (
    <>
      <Container>
        <MKBox
          color="black"
          variant="gradient"
          p={3}
          position="relative"
          sx={{
            backgroundColor: "#FFF",
            display: "grid",
            placeItems: "right",
            backgroundSize: "cover",
          }}
        >
          <br />
          <MKTypography variant="h3" fontSize="17px" fontWeight="light" color="secondary">
            <span className="material-icons-outlined">info</span>Identificación
          </MKTypography>
          <hr />
          <table>
            <tr>
              <td colSpan={2}>
                <MKTypography variant="body2">
                  <b>Ubicación:</b> {property?.street}, {property?.suburb?.name}
                </MKTypography>
              </td>
            </tr>
            <tr>
              <td>
                <MKTypography variant="body2">
                  <b>Zona:</b> {property?.zone?.name}
                </MKTypography>
              </td>
              <td>
                <MKTypography variant="body2">
                  <b>Manzana:</b> {property?.block?.name}
                </MKTypography>
              </td>
            </tr>
          </table>
          <br />
          <MKTypography variant="h3" fontSize="17px" fontWeight="light" color="secondary">
            <span className="material-icons-outlined">settings</span>Características
          </MKTypography>
          <hr />
          <table>
            <tr>
              <td colSpan={3}>
                <MKTypography variant="body2">
                  <b>Tipo:</b> {property?.propertytype?.name}
                </MKTypography>
              </td>
              <td>
                <MKTypography variant="body2">
                  <b>Piso:</b> {property?.flat_type?.name}
                </MKTypography>
              </td>
              <td>
                <MKTypography variant="body2">
                  <b>Actividad:</b> {property?.business_activity?.name}
                </MKTypography>
              </td>
            </tr>
          </table>
          <br />
          <MKTypography variant="h3" fontSize="17px" fontWeight="light" color="secondary">
            <span className="material-icons-outlined">history</span>Datos Históricos
          </MKTypography>
          <hr />
          <table>
            <tr>
              <td colSpan={3}>
                <MKTypography variant="body2">{property?.history_data}</MKTypography>
              </td>
            </tr>
          </table>
        </MKBox>
      </Container>
    </>
  );
}

export default PropertyDetails;
